import api from '../api';

export const deleteCategoryApi = (id) =>
  api.delete(`/LooseItemCategory?id=${id}`).then((res) => res);

export const updateCategoryApi = (params) =>
  api.put(`/LooseItemCategory`, params).then((res) => res);
